module.exports = __webpack_public_path__ + "static/media/1010658.a8b5630a.jpg";